
<template>
  <div>
    <v-autocomplete
      v-model="model.driver"
      :items="all_drivers"
      item-text="name"
      return-object
      label="Motorista"
      :readonly="loading_drivers"
      :loading="loading_drivers"
      prepend-icon="mdi-card-account-details"
      :rules="object_required"
    >
      <template v-slot:selection="{item}">
        {{ item.name }}
      </template>
      <template v-slot:item="{ item }">
        <v-list-item-content>
          <v-list-item-title > Nome: <b> {{item.name}} </b> </v-list-item-title>
        </v-list-item-content>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import Api from '@/api/index.js'
import validations from '@/mixins/validations.js'

export default {
  name: 'SelectDriver',
  mixins: [ validations ],
  props: {
    model: {
      type: Object,
    },
  },
  data() {
    return {
      loading_drivers: true,
      all_drivers: [],
    }
  },
  methods: {
    getFilter(){
      return {modality_ids: [this.model.modality_id], external: true, short: true}
    },
    getDrivers() {
      this.all_drivers = []
      this.loading_drivers = true
      let filter = this.getFilter()
      Api.Driver.index(filter).then(r=>r.data).then(d=>{
        d = d.data? d.data.map(ds=>ds.attributes) : d
        this.all_drivers = [...d]
      }).catch(err=>{
        console.error(err);
      }).finally(()=>{
        this.loading_drivers = false
      })
    },
  },
  computed: {
  },
  mounted () {
    this.getDrivers();
  },

}
</script>